import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ZONES } from "../../data/site";
import { Reveal } from "./Motion";

export const ZonesGrid = ({ exclude }) => {
  const zones = ZONES.filter(z => z.slug !== exclude);
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5" data-testid="zones-grid">
      {zones.map((z, i) => (
        <Reveal key={z.slug} delay={0.07 * i} className={i === 0 && zones.length === 5 ? "sm:col-span-2 lg:col-span-1" : ""}>
          <Link to={z.path} className="group relative block h-[360px] lg:h-[460px] overflow-hidden rounded-[28px] bg-forest" data-testid={`zone-card-${z.slug}`}>
            <img src={z.image} alt={`Traitement anti-moustique ${z.name}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-forest/95 via-forest/30 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6 text-cream">
              <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-lime">{z.tag}</p>
              <h3 className="mt-2 font-display text-3xl font-extrabold leading-none">{z.name}</h3>
              <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold">Voir le secteur <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" /></span>
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  );
};
